import { render, staticRenderFns } from "./GoodBook.vue?vue&type=template&id=031dac12&"
import script from "./GoodBook.vue?vue&type=script&lang=js&"
export * from "./GoodBook.vue?vue&type=script&lang=js&"
import style0 from "./GoodBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports